"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorMessage = void 0;
const ttag_1 = require("ttag");
exports.ErrorMessage = {
    get RegistrationInProgress() {
        return (0, ttag_1.c)('B1.Account.SignIn.Status').t `An existing registration request is already in progress.`;
    },
    get GenericRegistrationFail() {
        return (0, ttag_1.c)('B1.Account.SignIn.Error').t `A server error occurred while trying to register. Please try again.`;
    },
    get RateLimited() {
        return (0, ttag_1.c)('B2.NavSharedUI.Error').t `Too many successive server requests. Please wait a few minutes and try again.`;
    },
    get InsufficientPasswordMessage() {
        return (0, ttag_1.c)('B1.Account.SignIn.Error')
            .t `Your password must be at least %LENGTH% characters in length. For your security, please choose a longer password or, ideally, a passphrase, and try again.`;
    },
    get PasscodeRequired() {
        return (0, ttag_1.c)('B1.Account.SignIn.Error').t `Your passcode is required in order to register for an account.`;
    },
    get GenericInProgress() {
        return (0, ttag_1.c)('B2.NavSharedUI.Error').t `An existing request is already in progress.`;
    },
    get GenericFail() {
        return (0, ttag_1.c)('B2.NavSharedUI.Error').t `A server error occurred. Please try again.`;
    },
};
